import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getMyData(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-data/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getMyDataReduced(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-data/reduced/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getAccountPaymentPerson(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-payment-person/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getAccountPayment(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-data/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getWhiteLabelData(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/whiteLabel/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    personalData(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/personal-data/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNAccountProxy);

const SPE_VIEW_N_MENU = '/spe-view-n-menu';
let SpeViewNMenuProxy = class SpeViewNMenuProxy {
    constructor(api) {
        this.api = api;
    }
    getMenu(uuidWhiteLabel, uuidAccountPayment, type) {
        const uri = `${SPE_VIEW_N_MENU}/v1/build-menu/WL/${uuidWhiteLabel}/AP/${uuidAccountPayment}/menu-type/${type}`;
        return this.api.get(uri);
    }
    getMenuFilter(uuidWhiteLabel, uuidAccountPayment, type) {
        const uri = `${SPE_VIEW_N_MENU}/v1/list/WL/${uuidWhiteLabel}/AP/${uuidAccountPayment}/menu-type/${type}`;
        return this.api.get(uri);
    }
};
SpeViewNMenuProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNMenuProxy);

const SPE_EXT_OAUTH = '/spe-ext-oauth';
let SpeExtOauthProxy = class SpeExtOauthProxy {
    constructor(api) {
        this.api = api;
    }
    consultValidationPassword(body, accountPayment) {
        const uri = `${SPE_EXT_OAUTH}/oauth2/v1/validation-password`;
        return this.api.post(uri, body, accountPayment);
    }
};
SpeExtOauthProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeExtOauthProxy);

const SPE_EXT_OAUTH$1 = '/spe-ext-users';
let SpeExtUsersProxy = class SpeExtUsersProxy {
    constructor(api) {
        this.api = api;
    }
    validationPasswordEmail(body, accountPayment) {
        const uri = `${SPE_EXT_OAUTH$1}/v1/password/validation`;
        return this.api.post(uri, body, accountPayment);
    }
    updateValidationPassword(body, accountPayment) {
        const uri = `${SPE_EXT_OAUTH$1}/v1/password`;
        return this.api.put(uri, body, accountPayment);
    }
};
SpeExtUsersProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeExtUsersProxy);

let UiPxMyDataModule = class UiPxMyDataModule {
};
UiPxMyDataModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiBsOauthModule],
        providers: [ConfigService, SpeViewNAccountProxy, SpeViewNMenuProxy, SpeExtOauthProxy, SpeExtUsersProxy],
    })
], UiPxMyDataModule);

var DeletedEnum;
(function (DeletedEnum) {
    DeletedEnum["FALSE"] = "FALSE";
    DeletedEnum["TRUE"] = "TRUE";
})(DeletedEnum || (DeletedEnum = {}));

export { ConfigService, DeletedEnum, SpeExtOauthProxy, SpeExtUsersProxy, SpeViewNAccountProxy, SpeViewNMenuProxy, UiPxMyDataModule };
//# sourceMappingURL=wlp-ui-px-my-data.js.map
